import {
  csx,
  Table,
  TBody,
  TBodyCell,
  TBodyRow,
  THead,
  THeadCell,
} from '@vtex/admin-ui'
import { useNavigation } from '@vtex/raccoon-next'
import { Event, type SimplifiedPromotion } from 'typings'
import { useAnalytics } from 'use-analytics'
import { usePromotionsListState } from '../usePromotionsListState'

export function TableBody() {
  const { track } = useAnalytics()
  const { navigate } = useNavigation()
  const {
    tableState,
    viewState: { status },
    paginationState: { range },
    searchState: { value: searchTerm },
    filtersState,
  } = usePromotionsListState()

  const {
    getTable,
    getHeadCell,
    getBodyCell,
    columns,
    data: items,
  } = tableState

  const pageItems = items.slice(range[0] - 1, range[1])

  function handleNavigate(item: SimplifiedPromotion) {
    navigate(`/${item.id}`)
  }

  return (
    <Table
      {...getTable()}
      className={csx({
        width: 'full',
        'td[role=cell]:first-child div':
          status === 'ready'
            ? {
                display: 'grid',
                placeContent: 'center start',
                span: {
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              }
            : {},
      })}
    >
      <THead>
        {columns.map((column, colIndex) => (
          <THeadCell {...getHeadCell(column)} key={colIndex} />
        ))}
      </THead>
      <TBody>
        {pageItems.map((item) => (
          <TBodyRow
            key={item.id}
            {...(status === 'ready' && {
              onClick: () => {
                handleNavigate(item)

                track(Event.NAVIGATED_TO_PROMOTION, {
                  type: item.type,
                  status: item.status,
                  archived: false,
                  source: 'row-click',
                  appliedFilters: [
                    ...(searchTerm ? ['textSearch'] : []),
                    ...filtersState
                      .filter((f) => f.values.length)
                      .map((f) => f.id),
                  ],
                })
              },
            })}
          >
            {columns.map((column, colIndex) => (
              <TBodyCell
                {...getBodyCell(column, item)}
                key={colIndex}
                className={csx({ height: 70 })}
              />
            ))}
          </TBodyRow>
        ))}
      </TBody>
    </Table>
  )
}
